<template>
    <div class="wrapper">
        <a @click="back" class="back" style="position: absolute">&lt; {{$t("homePage.back")}}</a>
        <div style="text-align: center" v-loading="!imageUrl">
            <img v-show="imageUrl" :src="imageUrl" class="image"/>
        </div>
        <p style="text-align: center">{{$t("homePage.title")}}</p>
        <div class="color-description">
            <div>
                <div style="background: #999"/>
                <span>{{$t('homePage.full')}}</span>
            </div>
            <div>
                <div style="background: #1c6ca1"/>
                <span>{{$t('homePage.bookable')}}</span>
            </div>
            <div>
                <div style="background-color: #D58400"></div>
                <span> 当日(予約不可)</span>
            </div>
            <p style="margin-top: 0;font-size: 90%;">
                ・当日のWeb予約はできません。空き状況など、080-2601-9619にお問い合わせください。 <br/>
                ・当日はご予約時間の３０分前に起こしください。<br/>
                ・小学生以下の子供のみではご利用いただけません。必ず保護者の方も含めてご予約ください。
            </p>
        </div>
        <BookingCalendar ref="calendar" @chooseTimeRange="onChooseTimeRange"/>
    </div>
</template>

<script>
    import Pages from "../../../router/Pages";
    import FacilityApi from "../../../api/facility/FacilityApi";

    export default {
        name: "SelectBooking",
        mounted() {
            let facilityCode = this.$route.query.facilityCode;
            this.facilityCode = facilityCode;
            if (facilityCode) {
                FacilityApi.getLogoUrl(facilityCode)
                    .then(response => this.imageUrl = response);

                this.$refs.calendar.reload(facilityCode);
            }
        },
        data() {
            return {
                facilityCode: "",
                imageUrl: "",
            }
        },
        methods: {
            onChooseTimeRange(timeRange) {
                this.$router.push(Pages.orderBooking.path +
                    "?timeRangCode=" + timeRange.code +
                    "&orderedDate=" + timeRange.date +
                    "&facilityCode=" + this.facilityCode);
            },
            back() {
                this.$router.push({path: Pages.home.path});
            },
        },
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width: 770px) {
        .image {
            width: auto !important;
            max-width: 60% !important;
            height: 25vw !important;
            margin: 30px 0 !important;
        }
    }

    @media screen and (max-width: 600px) and (max-width: 1000px) {
        .wrapper {
            width: 100% !important;
        }
    }

    .wrapper {
        width: 90%;
        margin: auto;
        position: relative;
    }

    .image {
        width: 30%;
        margin: 0 35%;
    }

    .back {
        text-decoration: underline;
        color: #3C78D8;
        cursor: pointer;

        &:hover {
            color: #3264b4;
        }
    }


    .color-description {
        > div {
            display: inline-block;

            > div {
                display: inline-block;
                width: 80px;
                height: 25px;
            }

            > span {
                display: inline-block;
                height: 25px;
                position: relative;
                top: -6px;
                margin: 0 15px 0 7px;
            }
        }
    }
</style>